import { useField } from "formik";

import { Label, ValidationBadge } from "components/form";
import { classes } from "utils/classes";
import { getFieldTestId } from "utils/formik";

import { getErrorId } from ".";
import styles from "./CheckboxGroupField.scss";
import { FieldWithOptionsProps } from "./propTypes";

export const CheckboxGroupField = (props) => {
  const {
    label,
    name,
    values,
    disabled,
    dataTestId,
    className,
    inputClassName,
    labelClassName,
    required = false,
    tooltip,
    ...rest
  } = props;

  const [, checkboxGroupMeta] = useField(name);
  const testId = dataTestId || getFieldTestId(name);

  const makeLabel = (label, value) => (
    <label
      htmlFor={`form-checkbox-${name}-${value}`}
      className={classes(styles.label, labelClassName)}
      data-test-id={`${testId}-${value}-label`}
    >
      {label}
    </label>
  );

  return (
    <fieldset
      role="group"
      aria-labelledby="checkbox-group"
      className={styles.fieldset}
    >
      <Label
        text={label}
        required={required}
        tooltip={tooltip}
        dataTestId={`${testId}-label`}
      >
        {values.map(({ value, label }) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const [field] = useField({
            type: "checkbox",
            name,
            value,
          });

          return (
            <div
              key={`${name}-${value}`}
              className={classes(className, { [styles.disabled]: disabled })}
              data-test-id={testId}
            >
              <div className={styles.checkbox}>
                <input
                  {...field}
                  {...rest}
                  id={`form-checkbox-${name}-${value}`}
                  className={classes(styles.checkboxInput, inputClassName)}
                  disabled={disabled}
                  type="checkbox"
                  data-test-id={`${testId}-${value}`}
                />
                {makeLabel(label, value)}
              </div>
            </div>
          );
        })}
      </Label>
      <ValidationBadge
        error={checkboxGroupMeta.error}
        touched={checkboxGroupMeta.touched}
        errorId={getErrorId(name)}
        dataTestId={`${testId}-validation-badge`}
      />
    </fieldset>
  );
};

CheckboxGroupField.propTypes = FieldWithOptionsProps;
